import React from 'react';

import { Job, StriiveJobSourceEnum } from '@libs/graphql-types';

import { BayerSocialSecurityId } from './BayerSocialSecurityId';
import { DefaultSocialSecurityId } from './DefaultSocialSecurityId';
// import { DukeEnergySocialSecurityId } from './DukeEnergySocialSecurityId';
import { WtwSocialSecurityId } from './WtwSocialSecurityId';

interface SocialSecurityIdProps {
  job: Job;
  showOnlyRequired?: boolean;
}

/**
 * Component that renders different Social Security ID forms based on job source
 * Currently supports:
 * - Bayer: Custom form for Bayer jobs
 * - WTW: Custom form for WTW jobs (Client ID: 50831)
 * - Duke Energy: Custom form for Duke Energy jobs (Client ID: 51853)
 * - Default: Standard form for all other job sources
 */
export const SocialSecurityId: React.FC<SocialSecurityIdProps> = ({
  job,
  showOnlyRequired = false,
}) => {
  const jobSource = job?.striive_job?.source;

  switch (jobSource) {
    case StriiveJobSourceEnum.Bayer:
      return (
        <BayerSocialSecurityId job={job} showOnlyRequired={showOnlyRequired} />
      );
    case StriiveJobSourceEnum.Wtw:
      return (
        <WtwSocialSecurityId job={job} showOnlyRequired={showOnlyRequired} />
      );
    // FIXME: Replace this with the Duke type once it's updated in the API
    // case StriiveJobSourceEnum.Maximus:
    //   return (
    //     <DukeEnergySocialSecurityId
    //       job={job}
    //       showOnlyRequired={showOnlyRequired}
    //     />
    //   );
    case StriiveJobSourceEnum.HeadFirst:
    default:
      return (
        <DefaultSocialSecurityId
          job={job}
          showOnlyRequired={showOnlyRequired}
        />
      );
  }
};
